import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ModalButton from '../../../atomic/Buttons/ModalButton';
import SelectModal from '../../Modals/SelectModal';
import HeaderWrapper from '../HeaderWrapper';

const SelectModalStyled = styled(SelectModal)`
  max-width: 600px;
  width: 70%;
  min-width: 300px;
`;
const ModalButtonStyled = styled(ModalButton)`
  text-transform: none;
`;

class ModalSelect extends Component {
  constructor(props) {
    const { value } = props;
    super(props);
    this.state = {
      value: value,
    };
  }

  getValues = () => {
    const { text } = this.props;
    const { value } = this.state;
    if (value.length <= 0) {
      return text;
    } else {
      return value.map(item => item.label).join(', ');
    }
  }

  updateValue = value => {
    const { multiple, onChange } = this.props;
    const names = multiple ? value.map(item => item.value) : value[0].value;
    this.setState({value})
    onChange(names);
  }

  render() {
    const {
      options,
      multiple,
      header,
      ...other
    } = this.props;
    const { value } = this.state;

    return (
      <HeaderWrapper header={header} {...other}>
        <ModalButtonStyled
          selected={value.length > 0}
          modalComponent={(
            <SelectModalStyled
              header={header}
              options={options}
              multiple={multiple}
              defaultValue={value}
              onSubmit={this.updateValue}
              submitText="Select"
              {...other}
            />
          )}
          {...other}
        >
          {this.getValues()}
        </ModalButtonStyled>
      </HeaderWrapper>
    )
  }
}

ModalSelect.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.array,
};

ModalSelect.defaultProps = {
  value: [],
};

export default ModalSelect;
